/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_American_Studies20Inputs */

const en__field_enum_study_american_studies20 = /** @type {(inputs: _Field_Enum_Study_American_Studies20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Studies`)
};

const de__field_enum_study_american_studies20 = /** @type {(inputs: _Field_Enum_Study_American_Studies20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Studies`)
};

/**
* | output |
* | --- |
* | "American Studies" |
*
* @param {_Field_Enum_Study_American_Studies20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_american_studies20 = /** @type {((inputs?: _Field_Enum_Study_American_Studies20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_American_Studies20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_american_studies20(inputs)
	return de__field_enum_study_american_studies20(inputs)
});
export { _field_enum_study_american_studies20 as "_field_enum_STUDY_AMERICAN_STUDIES" }